import { useEffect } from 'react';

import { useUiConfig } from '@/hooks/useUiConfig';
import { setUiDebugEnabled } from '@/utils/logger';

export default function UiDebugInitializer() {
  const { debugLoggingEnabled } = useUiConfig();

  useEffect(() => {
    setUiDebugEnabled(debugLoggingEnabled);
  }, [debugLoggingEnabled]);

  return null;
}
